'use client';

import type { HousingProperty } from '@eliadmin/core/src/api/housing/housing-types';
import { ReservationFormStep1 } from '@eliadmin/core/src/components/reservation/reservation-form/reservation-form-step-1';
import { ReservationFormStep2 } from '@eliadmin/core/src/components/reservation/reservation-form/reservation-form-step-2';
import { ReservationFormStep3 } from '@eliadmin/core/src/components/reservation/reservation-form/reservation-form-step-3';
import { ReservationFormStep4 } from '@eliadmin/core/src/components/reservation/reservation-form/steps/reservation-form-step-4';

interface ReservationFormContentProps {
  step: number;
  properties: HousingProperty[];
  isLoadingProperties: boolean;
  isErrorProperties: boolean;
  onGoToStep: (step: number) => void;
}

export function ReservationFormContent({
  step,
  properties,
  isLoadingProperties,
  isErrorProperties,
  onGoToStep,
}: ReservationFormContentProps) {
  if (step === 1) return <ReservationFormStep1 />;
  if (step === 2)
    return (
      <ReservationFormStep2
        properties={properties}
        isLoading={isLoadingProperties}
        isError={isErrorProperties}
        onGoToStep={onGoToStep}
      />
    );
  if (step === 3) return <ReservationFormStep3 />;
  if (step === 4) return <ReservationFormStep4 properties={properties} onGoToStep={onGoToStep} />;
  return null;
}
